var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinance = function SvgFinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M13.962 11.223a10.5 10.5 0 0 0-2.984-5.744c-.345-.335-.517-.502-.897-.657-.381-.155-.708-.155-1.362-.155H7.28c-.654 0-.98 0-1.362.155-.38.155-.552.322-.897.657a10.5 10.5 0 0 0-2.984 5.744c-.325 1.96 1.482 3.443 3.5 3.443h4.923c2.02 0 3.826-1.484 3.5-3.443ZM4.838 2.962c-.138-.2-.337-.472.075-.534.423-.063.863.226 1.293.22.389-.005.587-.178.8-.424.224-.26.57-.89.994-.89.423 0 .77.63.994.89.213.246.411.419.8.424.43.006.87-.284 1.293-.22.412.062.213.334.075.534l-.622.905c-.266.387-.399.581-.677.69-.278.11-.638.11-1.357.11H7.495c-.72 0-1.08 0-1.358-.11-.278-.109-.411-.303-.677-.69z"
  })));
};
export default SvgFinance;